<ng-template #inviteExamineeModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">{{ title }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="inviteForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="gov_id" class="form-label">Person ID <span class="text-danger">*</span></label>
          <div class="input-container">
            <input type="text" class="form-control" [minlength]="6" id="gov_id" placeholder="Enter person ID" required formControlName="gov_id" [ngClass]="{ 'is-invalid': submitted && f['gov_id'].errors }" (input)="onSearchPerson()">
            @if (personLoading) {
              <div class="loading-overlay">
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          </div>
          <div class="invalid-feedback"> Please enter person ID </div>
          @if (persons.length > 0) {
            <div class="mt-2 text-warning">
              There are {{ persons.length === 1 ? 'person' : 'personas' }} with that ID <span class="text-info" [ngbTooltip]="getTooltipContent()">See details</span>
            </div>
          }
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="email" placeholder="Enter email address" required formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
          <div class="invalid-feedback"> Please enter email </div>
        </div>
        <div class="mb-3">
          <label for="phone" class="form-label">Phone number <span class="text-danger">*</span></label>
          <div class="input-group">
            <ng-select id="phone" style="width: 35%;" [items]="countryCodeData" bindValue="countryCode" [searchable]="true" name="phone_country_code" placeholder="+972" formControlName="phone_country_code" [searchFn]="customSearchFn">
              <ng-template ng-label-tmp let-item="item">
                <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryCode }}" />
                {{ item.countryCode }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryCode }}" />
                {{ item.countryCode }}
              </ng-template>
            </ng-select>
            <input type="text" class="form-control border-start-0" placeholder="525555555" formControlName="phone" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" />
          </div>
        </div>
        @if (!fromQuestionnairePage && !reInvite) {
          <div class="mb-3">
            <label for="questionnaire" class="form-label">Questionnaire <span class="text-danger">*</span></label>
            <ng-select [loading]="questionnaireLoading" [searchable]="false" [items]="questionnaires" id="questionnaire" bindLabel="name" placeholder="Select Questionnaire" [(ngModel)]="selectedQuestionnaire" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !selectedQuestionnaire }">
              <ng-template ng-header-tmp>
                <input style="width: 100%; line-height: 24px" type="text" (input)="onSearchQuestionnaire($event)" />
              </ng-template>
              <ng-template ng-loadingspinner-tmp>
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </ng-template>
            </ng-select>
            <div class="invalid-feedback"> Please select questionnaire </div>
          </div>
        }
        @if (fromQuestionnairePage || reInvite) {
          <div class="mb-3">
            <label for="questionnaire" class="form-label">Questionnaire</label>
            <input type="text" class="form-control" id="questionnaire" [(ngModel)]="selectedQuestionnaire!.name" [ngModelOptions]="{standalone: true}" [disabled]="fromQuestionnairePage || reInvite">
          </div>
        }
        <div class="mb-3">
          <label for="date-field" class="form-label">Expiration Date <span class="text-danger">*</span></label>
          <input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="false" [altFormat]="'Y-m-d H:i'" [minDate]="minExpiryDate" [enableTime]="true" [dateFormat]="'Y-m-d H:i'" [convertModelValue]="false" formControlName="time_expiration" [ngClass]="{ 'is-invalid': submitted && f['time_expiration'].errors }">
          <div class="invalid-feedback">Please select a date.</div>
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary btn-load" [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ reInvite ? 'Resend Invite' : 'Invite' }} </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
        }
        @if (success) {
          <h4 class="mb-3 mt-4">Examinee was {{ reInvite ? 're-invited' : 'invited' }} successfully.</h4>
        }
        @if (!success) {
          <h4 class="mb-3 mt-4">Failed to {{ reInvite ? 're-invited' : 'invited' }} Examinee.</h4>
        }
        <p class="text-muted fs-15 mb-4">{{ successMessage }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #detailsErrorModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">{{ detailsError.title }}</h4>
        <p class="text-muted fs-15 mb-4">{{ detailsError.message }}</p>
      </div>
      @if (detailsError.update) {
        <div class="row">
          <div class="col-md-6">
            <h4>Requested Details</h4>
            <p>Gov ID: {{ this.f['gov_id'].value }}</p>
            <p>Email: {{ this.f['email'].value }}</p>
            <p>Phone: {{ '+' + this.f['phone_country_code'].value + this.f['phone'].value }}</p>
          </div>
          <div class="col-md-6">
            <h4>Changed Details</h4>
            <p>Gov ID: <span [ngClass]="{'text-warning': exist_person.gov_id !== this.f['gov_id'].value}">{{ exist_person.gov_id }}</span></p>
            <p>Email: <span [ngClass]="{'text-warning': exist_person.email !== this.f['email'].value}">{{ exist_person.email }}</span></p>
            <p>Phone: <span [ngClass]="{'text-warning': ((exist_person.phone) !== this.f['phone'].value) || ((exist_person.phone_country_code) !== this.f['phone_country_code'].value)}">{{ '+' + exist_person.phone_country_code + '' + exist_person.phone }}</span></p>
          </div>
        </div>
      }
      <div class="text-end">
        @if (detailsError.update) {
          <button type="button" class="btn btn-danger btn-load me-2" (click)="onSubmit(0)">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> No do not update! </span>
            </span>
          </button>
        }
        <button type="button" class="btn btn-primary btn-load" [disabled]="submitted && spinner" (click)="detailsError.resend ? resendInvite() : onSubmit(1)">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ detailsError.resend ? 'Resend Invite' : 'Update' }} </span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">No Subscription Found</h4>
        <p class="text-muted fs-15 mb-4">You can not invite new user without an active subscription!</p>
      </div>
    </div>
  </div>
</ng-template>